<div mat-dialog-content class="large_dialog relative" role="dialog" aria-label="Contacto">
	
	<div class="flex_reverse flex_sm_column">
		<div class="two_thirds">
			<h3 class="title_next_to_corner_close_button margin_top_medium margin_bottom_small" tabindex="0">¿Tenés alguna consulta?</h3>

			<app-contact-form (eeSent)="onSent($event)"></app-contact-form>
		</div>

		<div class="line"></div>

		<div class="flex1">
			<h3 class="h3_contact fw500 v_margin_medium">Contacto</h3>

			<h4 class="margin_bottom_0">Email</h4>
			<p class="body1">{{email}}</p>

			<h3 class="fw500 margin_top_medium margin_bottom_small">Social Media</h3>

			<a href="https://www.linkedin.com/company/ecotopia-in" target="_blank" class="social_media_icon inline_block margin_right_medium" aria-label="LinkedIn">
				<svg>
					<use href="/assets/img/icons/linkedin_icon.svg#linkedIn_icon"></use>
				</svg>
			</a>
			<a href="https://www.instagram.com/ecotopia.arg" target="_blank" class="social_media_icon inline_block" aria-label="Instagram">
				<svg>
					<use href="/assets/img/icons/instagram_icon.svg#instagram_icon"></use>
				</svg>
			</a>
		</div>
	</div>

	<app-corner-button mat-dialog-close [ariaLabel]="'Cerrar díalogo de contacto'"></app-corner-button>

</div>